import { render, staticRenderFns } from "./StaffManager.vue?vue&type=template&id=21c28a69&scoped=true&"
import script from "./StaffManager.vue?vue&type=script&lang=js&"
export * from "./StaffManager.vue?vue&type=script&lang=js&"
import style0 from "./StaffManager.vue?vue&type=style&index=0&id=21c28a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c28a69",
  null
  
)

export default component.exports